import * as API from '@/services';
import { prepareContentWithBase64Images } from '@/utils';
import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import {
	formatCommonNoticeDetail,
	formatCommonNoticeList,
} from './common-notice.helper';
import { CommonNoticeActions } from './common-notice.redux';
import {
	ICreateNoticeRequest,
	IPayloadDeleteCommonNoticeRequest,
	IPayloadGetCommonNoticeDetailRequest,
	IPayloadGetCommonNoticeListRequest,
} from './common-notice.type';

export function* getCommonNoticeList(
	action: PayloadAction<IPayloadGetCommonNoticeListRequest>
) {
	const { callback, searchTypes, ...rest } = action.payload;

	try {
		// call api
		const res: API.ApiResponseSuccess<API.GetCommonNoticeListResponse> =
			yield API.getCommonNoticeList({ searchTypes, ...rest });
		const content = formatCommonNoticeList(res?.data?.content);

		yield put(
			CommonNoticeActions.getCommonNoticeListSuccess({
				...rest,
				content,
				total: res?.data?.total,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(CommonNoticeActions.getCommonNoticeListFailure());
	}
}

export function* createCommonNotice(
	action: PayloadAction<ICreateNoticeRequest>
) {
	const { callback, data } = action.payload;

	try {
		yield API.createCommonNotice(data);

		yield put(CommonNoticeActions.createCommonNoticeSuccess());

		callback?.();
	} catch (error: unknown) {
		callback?.(error as API.ApiResponseError);

		yield put(CommonNoticeActions.createCommonNoticeFailure());
	}
}

export function* deleteCommonNotices(
	action: PayloadAction<IPayloadDeleteCommonNoticeRequest>
) {
	const { callback, ids } = action.payload;

	try {
		yield API.deleteCommonNotice(ids);

		yield put(CommonNoticeActions.deleteCommonNoticeSuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(CommonNoticeActions.deleteCommonNoticeFailure());
	}
}

export function* getCommonNoticeDetail(
	action: PayloadAction<IPayloadGetCommonNoticeDetailRequest>
) {
	const { id, callback } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.ICommonNotice> =
			yield API.getCommonNoticeDetail(id);

		const detail = formatCommonNoticeDetail(res.data);

		const content: string = yield prepareContentWithBase64Images(
			detail.content
		);

		yield put(
			CommonNoticeActions.getCommonNoticeDetailSuccess({
				detail: {
					...detail,
					content,
				},
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(CommonNoticeActions.getCommonNoticeDetailFailure());
	}
}
